import { apiFetch, apiSend } from './client';
import type { ManagedUser } from './types';

/**
 * Every user the caller may administer, with the groups each of them reaches. Restricted to group admins by the
 * API. Membership itself is not changed here: adding somebody, changing their role and removing them go through
 * the group member endpoints in `./groups`, which carry the rules that protect the installation.
 */
export function listUsers(): Promise<ManagedUser[]> {
  return apiFetch<ManagedUser[]>('/api/users');
}

export function grantBulkEditor(userId: string): Promise<void> {
  return apiSend(`/api/users/${encodeURIComponent(userId)}/bulk-editor`, 'PUT');
}

export function revokeBulkEditor(userId: string): Promise<void> {
  return apiSend(`/api/users/${encodeURIComponent(userId)}/bulk-editor`, 'DELETE');
}
